import axios, { AxiosRequestConfig } from "axios";
import { FILE_STORAGE_API_ENDPOINT } from "../common";

export const getFileApi = (
  params: string | undefined,
  config: AxiosRequestConfig
) => {
  return axios.get(`${FILE_STORAGE_API_ENDPOINT}${params}`, config);
};
